'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IAccount = require('../../../common/iObjects/IAccount');

var _IAccount2 = _interopRequireDefault(_IAccount);

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _Input = require('../../Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formatFunction = function formatFunction() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (value) {
        value = String(value);
        value = value.replace(/[^\d]/gi, '').substr(0, 16);
    }
    return new _IAccount2.default(value).toString('card');
};

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _initialiseProps.call(_this);

        var value = null;

        if (_this.props.bind) {
            if (props.storage && props.attribute && typeof props.storage.get === 'function') {
                value = props.storage.get(props.attribute);
            }
        } else {
            value = props.value;
        }

        _this.state = _this._getEmitent(value);

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: '_getEmitent',
        value: function _getEmitent() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var visa = false,
                mc = false;

            if (value) {
                value = new _IAccount2.default(value);

                if (value.isVisa()) {
                    visa = value.isCard();
                } else if (value.isMasterCard()) {
                    mc = value.isCard();
                }
            }

            return {
                visa: visa,
                mc: mc
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var classList = this.compileStyle(_index2.default),
                props = {},
                _props = this.props,
                issuer = _props.issuer,
                theme = _props.theme;

            var issuerContent = null;

            if (issuer) {
                issuerContent = _react2.default.createElement('div', { className: classList.issuer });
            }

            // data bind keeps value in own HOC
            if (this.props.bind) {
                props.format = this._format;
                props.stringify = this._stringify;
            } else {
                // controlled component keeps value in parent state
                props.value = this._stringify(this.props.value);
            }

            return _react2.default.createElement(
                'div',
                { className: classList.root + ' ' + (this.props.className || '') },
                issuerContent,
                _react2.default.createElement(_Input2.default, _extends({}, this.props, props, {
                    style: Object.assign({
                        paddingRight: theme.appearanceWidth,
                        width: '100%'
                    }, this.props.style)
                    // class name should'n be passed
                    , className: '',
                    theme: null,
                    onChange: this._handleChange
                }))
            );
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.issuer) + String(this.state.visa) + String(this.state.mc);
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    placeholder: '0000 0000 0000 0000',
    valueOfOptions: ['card'],
    maxLength: 23,
    autoComplete: 'off',
    floating: false,
    type: 'tel',
    issuer: true
};
Main.propTypes = {
    onChange: _propTypes2.default.func,
    format: _propTypes2.default.func,
    className: _propTypes2.default.string,
    theme: _propTypes2.default.object,
    issuer: _propTypes2.default.bool
};
Main.displayName = 'CardInput';

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this._handleChange = function () {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var state = _this2._getEmitent(event.target.value);

        if (_this2.state.visa !== state.visa || _this2.state.mc !== state.mc) {
            _this2.setState(state);
        }

        if (typeof _this2.props.onChange === 'function') {
            _this2.props.onChange(event);
        }

        return _this2;
    };

    this._stringify = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (value && typeof value.toString === 'function') {
            return value.toString('card');
        } else {
            return value || '';
        }
    };

    this._format = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (typeof _this2.props.format === 'function') {
            return _this2.props.format(value);
        } else {
            return formatFunction(value);
        }
    };
};

exports.default = Main;